import { render, staticRenderFns } from "./TxDetailDialog.vue?vue&type=template&id=976bac04&scoped=true&"
import script from "./TxDetailDialog.vue?vue&type=script&lang=js&"
export * from "./TxDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./TxDetailDialog.vue?vue&type=style&index=0&id=976bac04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976bac04",
  null
  
)

export default component.exports